import { checkValue } from '../../utils';

export const customers = (state) => state.customers.get('customers').toJS();
export const customerData = (state) =>
  state && state.customers && state.customers.get && state.customers.get('customerData');
export const getAddress = (state) => {
  const customerAddress =
    state.customers.get('personalAddress') && state.customers.get('personalAddress').toJS();
  if (customerAddress) {
    const houseNo = customerAddress.hasOwnProperty('house_number') && customerAddress.house_number;
    const addressPrefix =
      customerAddress.hasOwnProperty('address_prefix') && customerAddress.address_prefix;
    const street = customerAddress.hasOwnProperty('street') && customerAddress.street;
    const city = customerAddress.hasOwnProperty('city') && customerAddress.city;
    const postcode = customerAddress.hasOwnProperty('postal_code') && customerAddress.postal_code;
    return `${checkValue(houseNo)}${checkValue(addressPrefix)}${checkValue(street)}${checkValue(
      city
    )}${checkValue(postcode).replace(',', '')}`;
  }
  return '';
};
